export default __webpack_public_path__ + "static/media/login-bg.11b8df37.png";